import React from 'react';
import Autosuggest from 'react-autosuggest';
import autocompleteApi from '../../api/generalAutocompleteApi'
import attributeSearchAutoCompleteApi from '../../api/attributeSearchAutocompleteApi'

const getSuggestionValue = suggestion => suggestion.value;

const renderSuggestion = suggestion => (
  <div>
    {suggestion.value}
  </div>
);

class SearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLabelVisible: false,
      suggestions: [],
    };
  }

  resetValue = () => {
    this.props.selectInput('');
  };

  handleLabelVisibility = (event) => {
    if (event.type === 'focus') {
      this.setState(state => ({ isLabelVisible: true }));
    }
    else if (!this.props.value) {
      this.setState(state => ({ isLabelVisible: false }));
    }
  };

  handleChange = (event, { newValue }) => {
    this.props.selectInput(typeof newValue !== 'undefined' ? newValue : '');
  };

  onSuggestionSelected = (event, { suggestionValue }) => {
    this.props.submitResult(suggestionValue);
  };

  submitResult = event => {
    event.preventDefault();
    this.props.submitResult(this.props.value);
  };

  /**
   * @deprecated
   * @param {*} param0 
   * @returns 
   */
  onAttributeSuggestionsFetchRequested = ({ value }) => {
    if (!value) {
      return;
    }
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < 3) {
      this.setState({
        suggestions: [],
      });
      return;
    }
    const result = attributeSearchAutoCompleteApi({
      search: value,
      filters: this.props.filters.filters,
      attributeFilters: this.props.filters.attributeFilters,
    }).then((result) => {
      if (result) {
        this.setState({
          suggestions: result,
        });
      }
      else {
        this.setState({
          suggestions: [],
        });
      }
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (!value) {
      return;
    }
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < 3) {
      this.setState({
        suggestions: [],
      });
      return;
    }
    const result = autocompleteApi({search: value}).then((result) => {
      if (result) {
        this.setState({
          suggestions: result,
        });
      }
      else {
        this.setState({
          suggestions: [],
        });
      }
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const {isLabelVisible, suggestions} = this.state;
    const {inputCustomLabel, inputCustomClassName, generalSearch, submitResult, value, selectInput, ...rest} = this.props;
    const inputProps = {
      ...rest,
      value: value || '',
      onChange: this.handleChange,
      onBlur: this.handleLabelVisibility,
      onFocus: this.handleLabelVisibility,
      className: "form-text input-symbol react-search-input input-" + inputCustomClassName + (value ? " has-value" : ""),
    };
    return (
      <div className="react-search-input-wrapper form-item form-type-textfield form-type-symbol">
        <label className={ isLabelVisible ? "visible": ""}>{inputCustomLabel}</label>
        <div className={"input-cell" + (value ? " has-value" : "")}>
          <Autosuggest
            suggestions={suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            /* onSuggestionsFetchRequested={generalSearch ? this.onSuggestionsFetchRequested : this.onAttributeSuggestionsFetchRequested} */
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            onSuggestionSelected={this.onSuggestionSelected}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
        </div>
      </div>
    );
  }
}

export default SearchInput
